import fb from './firebaseConfig';

export const getUser = () => {
  return new Promise<any>((resolve: any) => {
    fb.usersCollection.get().then(res => {
      if (!res.docs || !res.docs.length) {
        throw new Error('"users" collection doesn\'t exist or empty ' +
          'but should have at least one user. Check it please.');
      }
      resolve(res.docs[0].data());
    }).catch(err => {
      throw err;
    });
  });
};
